import { AxiosRequestConfig } from 'axios';
import { isLoggedIn, getToken } from 'data-layer-cr/dist/authentication';

/**
 * A method to be used as an interceptor for requests that need the authorization
 * information in their headers.
 *
 * @param conf - The axios configuration
 */
export default function injectAuthorization(
  conf: AxiosRequestConfig,
): AxiosRequestConfig | Promise<AxiosRequestConfig> {
  if (isLoggedIn()) {
    return {
      ...conf,
      headers: {
        ...conf.headers,
        Authorization: `Bearer ${getToken()}`,
      },
    };
  }
  return {
    ...conf,
    headers: {
      ...conf.headers,
    },
  };
}
